import React from 'react';
import { FUZZY_INIT, FUZZY_INIT_SUCCESS, FUZZY_CLEAR } from 'constants/ActionTypes';
import Context from 'managers/Context';
import { cacheEntityValues } from 'services/Fuzzy';
import {
    getSrcCompanyCircleAvatar,
    getSrcContactCircleAvatar,
    getSrcUserCircleAvatar,
} from 'utils/getSrcAvatar';
import OpportunityIcon from 'containers/opportunities/components/icons/OpportunityIcon';

export function getEntityCustomization(item, list) {
    const id = item?.id || item?.Id || item?.value;

    switch (list) {
        case 'usuarios':
        case 'users':
        case 'viewusuariosfullname':
        case 'fullusuarios': {
            const { src, fallbackSrc } = getSrcUserCircleAvatar(id);
            return { src, placeholder: fallbackSrc };
        }
        case 'empresas':
        case 'companies':
        case 'companyrates': {
            const { src, fallbackSrc } = getSrcCompanyCircleAvatar(id);
            return { src, placeholder: fallbackSrc };
        }
        case 'contactos':
        case 'contacts': {
            const { src, fallbackSrc } = getSrcContactCircleAvatar(id);
            return { src, placeholder: fallbackSrc };
        }
        case 'expedientes':
        case 'opportunities': {
            return {
                icon: (
                    <OpportunityIcon
                        expirationDays={item?.ExtraInfo4}
                        lost={item?.ExtraInfo6}
                        won={item?.ExtraInfo5}
                    />
                ),
            };
        }
        default:
            return {};
    }
}

function transformData({ data = [], list }) {
    return data.map((item) => ({
        ...item,
        value: item.Id,
        label: item.MatchingInfo,
        ...getEntityCustomization(item, list),
    }));
}

export function clearFuzzy(entity, field) {
    return function (dispatch) {
        dispatch({
            type: FUZZY_CLEAR,
            entity,
            field,
        });
    };
}

export function getFuzzy({
    list,
    field,
    text,
    feature,
    parentField,
    parentValue,
    idParent,
    environmentId,
    excludeDisabledStates,
}) {
    return function (dispatch, getState) {
        // Check if we have value already
        let fuzzyName = list;
        if (field) fuzzyName += `_${field}`;
        if (parentField && parentValue) {
            fuzzyName += `_${parentField}_${parentValue}`;
        }
        if (idParent) fuzzyName += `_idParent-${idParent}`;
        if (environmentId) fuzzyName += `_environmentId-${environmentId}`;
        if (excludeDisabledStates) fuzzyName += '_excludeDisabledStates';
        const state = getState().fuzzy;
        if (
            state &&
            state[fuzzyName] &&
            state[fuzzyName].data.length > 0 &&
            state[fuzzyName].text === text
        ) {
            return Promise.resolve(state[fuzzyName].data);
        }

        return new Promise((resolve, reject) => {
            dispatch({
                type: FUZZY_INIT,
                text,
                list,
                field,
                feature,
                parentField,
                parentValue,
                idParent,
                environmentId,
            });
            Context.domainManager.autoCompleteSearch({
                entity: list,
                field,
                search: text,
                feature,
                parentField,
                parentValue,
                idParent,
                environmentId,
                excludeDisabledStates,
                success: (data) => {
                    cacheEntityValues(list, data);
                    const finalData = transformData({ data, list });
                    dispatch({
                        type: FUZZY_INIT_SUCCESS,
                        data: finalData,
                        text,
                        list,
                        field,
                        feature,
                        parentField,
                        parentValue,
                        idParent,
                        environmentId,
                    });
                    resolve(finalData);
                },
                error: (err) => {
                    console.error(err);
                    reject(err);
                },
            });
        });
    };
}

export function getFuzzyCompaniesCampaigns({ text, idCampaign }) {
    return function () {
        return new Promise((resolve, reject) => {
            Context.domainManager.autoCompleteSearchCompaniesCampaign(
                text,
                idCampaign,
                (data) => {
                    const finalData = transformData({ data, list: 'empresas' });
                    resolve(finalData);
                },
                (err) => {
                    console.error(err);
                    reject(err);
                },
            );
        });
    };
}
